import React from "react";
import MyIcon from "../MyIcon";
import ContactIcon from "../../../assets/icons/contacts_main.svg2";
import OverviewIcon from "../../../assets/icons/overview-01.svg2";
import TickIcon from "../../../assets/icons/tick.svg2";

export default function OverviewYourImport() {
  return (
    <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker m-3 fw-bold ">
      <div className="d-inline-block">
        <div className="d-flex">
          <div className="me-2">
            <MyIcon Icon={OverviewIcon} width={40} />
          </div>
          <div>
            <h5 className="fw-bold"> Overview of your import</h5>
            <h6 className="text-secondary">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </h6>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <span>
          <MyIcon Icon={ContactIcon} width={30} className="me-2 " />
        </span>
        You imported the following <span className="text-purple p-1">8</span>
        fields into
        <span className="text-purple ms-1"> Contacts:</span>
      </div>
      <div
        className="overflow-auto d-flex flex-column p-3"
        style={{
          maxHeight: 200,
          scrollbarColor:
            "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
        }}
      >
        <div className="mt-3">
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">First Name</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Last Name</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Company</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Role</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Telephone</h5>
          </span>{" "}
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Email</h5>
          </span>{" "}
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Location</h5>
          </span>
          <span className="d-flex align-items-center">
            <TickIcon width={15} className="text-purple" />
            <h5 className=" p-1 small ms-2">Opt-in</h5>
          </span>
        </div>
      </div>
    </div>
  );
}
